

















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { stringToBig } from '@/helper'
import { DCM_ID } from '@/known_assets'
import { DEFAULT_NETWORK_NAME } from '@/store/modules/network/network'

@Component({})
export default class AddressResult extends Vue {
    @Prop() item!: any | null

    select() {
        // TODO: support for multiple chains. add a chain param
        this.$router.push({
            path: `/address/AST-${this.item.address}`,
            query: { network: DEFAULT_NETWORK_NAME },
        })
        this.$emit('select')
    }

    get dcmBalance() {
        return stringToBig(
            this.item.assets[DCM_ID].balance,
            this.dcmDenomination
        )
    }

    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }

    get dcmDenomination() {
        // console.log("clo",this.$store.state.assets[DCM_ID].denomination)
        // return this.$store.state.assets[DCM_ID].denomination
        return 9
    }

    get dcmSymbol() {
        // console.log("clo",this.$store.state.assets[DCM_ID].symbol)
        // return this.$store.state.assets[DCM_ID].symbol
        return 'DCM'
    }

    get numTx() {
        return this.item.transactionCount
    }

    get chainNow() {
        return this.$store.state.chainId
    }

    get prefixedAddress() {
        if (
            this.item.chainID ==
            '2S1QKgcu1CAaKTkMA2gtQUEpsrWkJaJAZp5RuJQFuEamTVdzEf'
        ) {
            return `AST-${this.item.address}`
        } else if (
            this.item.chainID == '11111111111111111111111111111111LpoYY'
        ) {
            return `ATH-${this.item.address}`
        }
        return `${this.chainNow}-${this.item.address}`
    }
}
